import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
})
export class TextFieldComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() placeholder: string = '';
  @Input() errorMessage: string = '';
  @Input() type: string = 'text';
  @Input() isDisabled: boolean = false;
  private readonly phoneAllowedPattern = /^[0-9+]*$/;

  ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
    else {
      this.control.enable();
    }
  }

  onBlur(): void {
    if (this.type === 'number' && this.control.value !== null && this.control.value !== undefined) {
      const value = parseFloat(this.control.value);
      if (!isNaN(value)) {
        // Truncate to 2 decimal places without rounding
        const truncatedValue = Math.floor(value * 100) / 100;
        this.control.setValue(truncatedValue.toString());
      }
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.type !== 'tel') {
      return;
    }

    const allowedControlKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    if (allowedControlKeys.includes(event.key)) {
      return;
    }

    if (!this.phoneAllowedPattern.test(event.key)) {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    if (this.type !== 'tel') {
      return;
    }

    const inputElement = event.target as HTMLInputElement;
    const sanitizedValue = (inputElement.value || '').replace(/[^0-9+]/g, '');

    if (sanitizedValue !== inputElement.value) {
      inputElement.value = sanitizedValue;
      this.control.setValue(sanitizedValue);
    }
  }
}
